import React, { useState, useEffect } from 'react';
import { Button, Input, Table, Breadcrumb, Tooltip } from 'antd';
import { HomeOutlined } from '@ant-design/icons';
import { deleteTypeOffer, fatchTypeOffers } from '../../../../services/offers/typeOffersApi';
import { toast, ToastContainer } from 'react-toastify';
import AjouterTypeOffer from './modals/AjouterTypeOffer';
import EditTypeOffer from './modals/EditTypeOffer';
import ConfirmationModal from './modals/ConfirmationModal';
import './typeOffer.css'


function TypeOffers (props) {

    const [typeOffers, setTypeOffers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [search, setSearch] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage] = useState(10);
    const [isOpenAddModal, setIsOpenAddModal] = useState(false);
    const [isOpenEditModal, setIsOpenEditModal] = useState(false);
    const [typeOfferToEdit, setTypeOfferToEdit] = useState(null);
    const [isOpenConfirmDelete, setIsOpenConfirmDelete] = useState(false);
    const [typeOfferToDelete, setTypeOfferToDelete] = useState(null);

    useEffect(() => {
        loadTypeOffers();
    }, [search, currentPage]);

    const loadTypeOffers = () => {
        setLoading(true);
        fatchTypeOffers(search, perPage, currentPage)
            .then((response) => {
                setTypeOffers(response.data.types);
                setTotalRows(response.data.totalRows);
                setLoading(false);
            })
            .catch((error) => {
                setLoading(false);
                toast.error('Error fetching type offers.');
            });
    };

    const handleDeleteTypeOffer = () => {
        if (typeOfferToDelete) {
            deleteTypeOffer(typeOfferToDelete.id)
                .then(() => {
                    toast.success('Type offer deleted successfully!');
                    loadTypeOffers();
                    setIsOpenConfirmDelete(false);
                })
                .catch((error) => {
                    toast.error('Error deleting type offer.');
                });
        }
    };

    const columns = [
        {
            title: 'Nom',
            dataIndex: 'nom',
            key: 'nom',
        },
        {
            title: <div style={{ paddingRight: '40px' }}>Actions</div>,
            dataIndex: 'actions',
            key: 'actions',
            align: 'right',
            render: (text, typeOffer) => (
                <span style={{ paddingRight: '20px' }}>
                    <Tooltip title="Edit">
                        <Button shape="circle" onClick={() => {
                            setTypeOfferToEdit(typeOffer);
                            setIsOpenEditModal(true);
                        }} icon={<i className="bi bi-pencil-square"></i>}>
                        </Button>
                    </Tooltip>
                    <Tooltip title="Delete">
                        <Button danger className="mx-2" shape="circle" onClick={() => {
                            setTypeOfferToDelete(typeOffer);
                            setIsOpenConfirmDelete(true);
                        }} icon={<i className="bi bi-trash"></i>}>
                        </Button>
                    </Tooltip>
                </span>
            ),
        },
    ];

    return (
        <>
            <div>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <h4 className='col-lg-11'>
                        <div className="mb-2">
                            <i className="bx bx-tag me-2" style={{color:"var(--primary-color3) !important"}}/>
                            <h3 style={{color:"var(--primary-color3) !important"}}>Type offers</h3>
                        </div>
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <HomeOutlined />
                            </Breadcrumb.Item>
                            <Breadcrumb.Item style={{color:"var(--primary-color3) !important"}}>Type offers</Breadcrumb.Item>
                        </Breadcrumb>
                    </h4>
                    <Button onClick={() => setIsOpenAddModal(true)} style={{ backgroundColor: 'var(--primary-color5)', color: "white" }}>
                        <span>Ajouter</span>
                    </Button>
                </div>
                <div style={{ display: 'flex', justifyContent: 'flex-end', margin: '10px 0' }}>
                    <Input
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Rechercher"
                        value={search}
                        suffix={<i className="bi bi-search" />}
                        style={{ width: '200px' }}
                    />
                </div>
                <div>
                    <Table
                        
                        dataSource={typeOffers}
                        columns={columns}
                        pagination={{ current: currentPage, total: totalRows, pageSize: perPage, onChange: setCurrentPage }}
                        loading={loading}
                        scroll={{ x: 1000 }}
                        
                    />
                </div>
            </div>
            <AjouterTypeOffer isOpen={isOpenAddModal} onClose={() => setIsOpenAddModal(false)} onSubmit={loadTypeOffers} />
            <EditTypeOffer 
                isOpen={isOpenEditModal} 
                onClose={() => setIsOpenEditModal(false)} 
                onSubmit={loadTypeOffers} 
                typeOffer={typeOfferToEdit} 
            />
            <ConfirmationModal 
                isOpen={isOpenConfirmDelete} 
                onClose={() => setIsOpenConfirmDelete(false)} 
                onConfirm={handleDeleteTypeOffer} 
            />
            <ToastContainer />
        </>
    );
};

export default TypeOffers;
